export default "__VITE_ASSET__jHfQw3YiXlQn6kvXU2r0Zw__"